import clsx from 'clsx';

import InfoIcon from '@ping/assets/Icon/circle-error.svg';
import { t } from '@ping/helpers';

import style from './style.module.scss';

interface IDepositErrorAlertProps {
  className?: string;
  errorMessage?: string;
}

export function DepositErrorAlert(props: IDepositErrorAlertProps) {
  const { className, errorMessage } = props;
  return (
    <div className={clsx(className, style['deposit-error-alert'])} role='alert'>
      <div className={style['deposit-error-alert__header']}>
        <InfoIcon />
        <span className={style['deposit-error-alert__title']}>{t('Unable to generate deposit address')}</span>
      </div>
      <p className={style['deposit-error-alert__description']}>
        {errorMessage || t('An error occurred while generating the deposit address. Please try again.')}
      </p>
    </div>
  );
}
